import { createPixel as createPixelCasalemedia } from './bidders/casalemedia'; // 2
import { createPixel as createPixelSonobi } from './bidders/sonobi'; // 9
import { createPixel as createPixelTriplelift } from './bidders/triplelift'; // 14
import { createPixel as createPixelRubicon } from './bidders/rubicon'; // 19
import { createPixel as createPixelOpenrtb } from './bidders/openrtb'; // 22
import { createPixel as createPixelAppnexus } from './bidders/appnexus'; // 23, 26, 29, 33
import { createPixel as createPixelSovrn } from './bidders/sovrn'; // 24
import { createPixel as createPixelBeachfront } from './bidders/beachfront'; // 42
import { createPixel as createPixelPubmaticEmea } from './bidders/pubmatic-emea'; // 46
import { createPixel as createPixelOath } from './bidders/oath'; // 57
import { createPixel as createPixel33across } from './bidders/33across'; // 59
import { createPixel as createPixelVerizon } from './bidders/verizon'; // 61
import { createPixel as createPixelMediagrid } from './bidders/mediagrid'; // 62
import { createPixel as createPixelSharethrough } from './bidders/sharethrough'; // 64
import { createPixel as createPixelOpenWeb } from './bidders/openweb'; // 65

const elements = [
  createPixelAppnexus(),
  createPixelOpenrtb(),
  createPixelSonobi(),
  createPixelSovrn(),
  createPixelTriplelift(),
  createPixelCasalemedia(),
  createPixelBeachfront(),
  createPixelPubmaticEmea(),
  createPixelRubicon(),
  createPixelOath(),
  createPixel33across(),
  createPixelVerizon(),
  createPixelMediagrid(),
  createPixelSharethrough(),
  createPixelOpenWeb(),
];

elements.forEach(element => document.body.appendChild(element));
